function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 10.5,
  cy: 10,
  r: 10,
  fill: "black"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.5 6.15432C16.0588 6.35031 15.5841 6.4823 15.0861 6.5419C15.5945 6.23712 15.9848 5.75475 16.1684 5.17999C15.6933 5.46237 15.1657 5.66676 14.6053 5.77755C14.1562 5.29918 13.5158 5 12.8082 5C11.4487 5 10.3464 6.10233 10.3464 7.46184C10.3464 7.65462 10.3684 7.84261 10.4104 8.023C8.36414 7.9206 6.55026 6.94027 5.33594 5.45077C5.12396 5.81435 5.00277 6.23712 5.00277 6.68829C5.00277 7.54223 5.43674 8.29578 6.09789 8.73735C5.69392 8.72456 5.31474 8.61376 4.98237 8.42937V8.46017C4.98237 9.65329 5.83151 10.648 6.95704 10.8748C6.75065 10.9308 6.53306 10.9612 6.30868 10.9612C6.14989 10.9612 5.9955 10.9456 5.84511 10.9168C6.15829 11.8947 7.06783 12.6067 8.14496 12.6267C7.30261 13.2867 6.24108 13.6806 5.08756 13.6806C4.88837 13.6806 4.69239 13.669 4.5 13.6458C5.58953 14.3442 6.88344 14.7522 8.27375 14.7522C12.8018 14.7522 15.2781 11.0008 15.2781 7.74781C15.2781 7.64102 15.2761 7.53463 15.2709 7.42944C15.7525 7.08146 16.17 6.64789 16.5 6.15432Z",
  fill: "white"
});

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.bdb468eb.svg";
export { ForwardRef as ReactComponent };